<template>
  <div class="locale-changer">
    <Dropdown
      v-model="$i18n.locale"
      :options="$i18n.availableLocales"
      placeholder=""
      :class="customclass"
    >
      <template #value="slotProps">
        <img
          src="assets/flags/flag_placeholder.png"
          :class="'flag flag-' + lang[slotProps.value].flag"
          width="30"
        />
        {{ lang[slotProps.value].name }}
      </template>
      <template #option="slotProps">
        <img
          src="assets/flags/flag_placeholder.png"
          :class="'flag flag-' + lang[slotProps.option].flag"
          width="30"
        />
        {{ lang[slotProps.option].name }}
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { loadLanguageAsync } from "../i18n";

export default {
  props: {
    customclass: String,
  },
  data() {
    return {
      lang: {
        de: {
          flag: "de",
          name: "Deutsch",
        },
        en: {
          flag: "gb",
          name: "English",
        },
        es: {
          flag: "es",
          name: "Español",
        },
        it: {
          flag: "it",
          name: "Italiano",
        },
        fr: {
          flag: "fr",
          name: "Français",
        },
        nl: {
          flag: "nl",
          name: "Dutch",
        },
        pl: {
          flag: "pl",
          name: "Polish",
        },
        pt: {
          flag: "pt",
          name: "Portuguese",
        },
      },
    };
  },
  watch: {
    "$i18n.locale": "changeLocale",
  },
  methods: {
    changeLocale: async function () {
      this.$store.commit("preferences/locale", this.$i18n.locale);

      await loadLanguageAsync(this.$i18n.locale);
    },
  },
};
</script>

<style>
.rightbar-local-changer {
  width: 100%;
  background-color: rgb(252, 251, 251);
}
.p-dropdown-panel {
  background-color: rgb(252, 251, 251);
}

.p-dropdown {
  width: 300px;
  border-radius: 10px;
  border-width: 1px;
  margin-bottom: 5rem;
}

.p-dropdown:not(.p-disabled).p-focus {
  box-shadow: 0 0 0 0.1rem rgba(33, 87, 94, 0.5);
}

.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background: rgba(33, 87, 94, 0.3);
}

.p-dropdown-label {
  font-family: raleway, sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: black;
}
</style>
